import type { MouseEvent } from "react";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { Button as MuiButton } from "@mui/material";
import { Button, RecordContextProvider, useRecordContext, type RaRecord } from "react-admin";

import { getRelayApprovalWhatsAppContext } from "./relay-approval-whatsapp-context";

type SendRelayApprovalInviteButtonProps = {
  record?: RaRecord;
  stopPropagation?: boolean;
  /** Toolbar (show page) vs compact full-width list row button. */
  variant?: "toolbar" | "list";
};

export default function SendRelayApprovalInviteButton({
  record: recordProp,
  stopPropagation = false,
  variant = "toolbar",
}: SendRelayApprovalInviteButtonProps) {
  const recordFromContext = useRecordContext<RaRecord>();
  const record = recordProp ?? recordFromContext;

  if (!record) {
    return null;
  }

  const { chatHref } = getRelayApprovalWhatsAppContext(record);

  const handleClick = (event: MouseEvent) => {
    if (stopPropagation) {
      event.stopPropagation();
    }
    if (!chatHref) {
      return;
    }
    window.open(chatHref, "_blank", "noopener,noreferrer");
  };

  if (variant === "list") {
    return (
      <MuiButton
        variant="outlined"
        size="small"
        fullWidth
        disabled={!chatHref}
        startIcon={<WhatsAppIcon fontSize="small" />}
        onClick={handleClick}
        sx={{ minHeight: 40, textTransform: "none" }}
      >
        Send invite
      </MuiButton>
    );
  }

  return (
    <Button label="Send invite" disabled={!chatHref} onClick={handleClick}>
      <WhatsAppIcon />
    </Button>
  );
}

export function SendRelayApprovalInviteAction({
  record,
  variant = "toolbar",
}: {
  record: RaRecord;
  variant?: "toolbar" | "list";
}) {
  return (
    <RecordContextProvider value={record}>
      <SendRelayApprovalInviteButton stopPropagation variant={variant} />
    </RecordContextProvider>
  );
}
